import React, {useState} from "react"
import {Button, FormLabel, Modal} from "react-bootstrap"
import {putConversation} from "../../lib/api";
import {EditableText} from "../Shared/EditableWidgets";
import {Conversation} from "./Conversations";

function ConversationsInstructions(props: {
  show: boolean;
  onHide: () => void;
}) {
  const {show, onHide} = props;


  return (
    <Modal show={show}
           className="conversations-instructions"
           animation={false}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Conversations Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <p>
              On Villa, every person that opens a web account on app.villa.rocks is automatically the Admin of their
              Org. You can have up to 10 Villas (and unlimited Galactica parcels which can be made public), each
              representing multiple virtual worlds that you can host meetings in for work, education, or entertainment.
            </p>
            <p>
              An exciting new feature is Conversations, which are AI guided tutorials for visitors of your Villas. The
              way this works is as follows:
            </p>
            <ol>
              <li>Click the Choose conversation to edit button</li>
              <li>Click New Conversation...</li>
              <li>Name your conversation by writing it into the top field. For example, you can say Intro to XYZ World
              </li>
              <li>
                Next click Add Prompt. Notice it says Script to the left, keep it on that for now. In the Prompt
                field, enter what you want the AI to greet your users with. For example: "Welcome to XYZ World, a
                virtual world of magic! I'll walk you through a few things about this world in this quick tutorial, so
                you can get acquainted! Excited to learn more?" Now users get to answer their turn, and ask any
                questions they'd like before moving to the next prompt.
              </li>
              <li>
                Next create the AI's next prompt by clicking the Add Prompt button. You can say for example, "Notice
                that I'll talk and the mic above my head will pulsate red. It's your turn when it turns yellow, and as
                soon as you talk it'll turn green. Once you finish I'll get your message. Go ahead and ask me a question"
              </li>
              <li>
                Next create the AI's next prompt by clicking the Add Prompt button. You can say for example, "In XYZ
                world, you can do a., b., c." and list the different things you'd like users to know about your world.
                And so on... you can go as long as you need, just remember most users may not be patient enough to go
                past 10 prompts or so... but you can test as you build this and do what works best for your venture.
              </li>
              <li>
                Tip: Remember that you can also customize the AI for your entire business/org, or just for a
                particular Villa by heading to Menu &gt; Customize AI. If you do that, don't forget that you AI will be
                weighting its responses based on that customization, so if you don't like it, simply delete it from there and the AI
                will give broad and general purpose answers. For example, if one of your Villas represents your
                Marketing department, this is a great place to post things related to that department. Or if it
                represents a Physics class, you can post knowledge there too. Or in our case above if the knowledge has to do with
                XYZ World, this is a great place to define all that, and then the Conversation AI will know how to introduce your
                users to it.
              </li>
              <li>
                How to use: Once you're done with the above, head to your designated Villa in VR, in this example to
                XYZ World. Now press A &gt; Spawn! &gt; AI Assistant &gt; and look to the rightmost tab for
                Conversations. Find your conversation, click on it, and your Avatar will start the tutorial. He'll be there from here on, first
                thing for every member of your org or guest (if public) that visits this world. If you want to remove
                it, select None from the Conversations dropdown in VR.
              </li>
            </ol>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <Button
            variant="Primary"
            className="ml-2"
            onClick={onHide}
          >
            OK
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ConversationsInstructions;
